/* eslint-disable array-callback-return */
import "../styles.css";
import { Link } from "react-router-dom";
import {
  MdOutlineArchive,
  MdDeleteOutline,
  MdOutlineEdit,
} from "react-icons/md";
import { useNotes, useArchive, useTrash } from "../context";

export default function Note() {
  const { notes, dispatch } = useNotes();
  const { addToArchiveHandler } = useArchive();
  const { trashNoteHandler } = useTrash();

  const checkUnpinNotes = (note) => {
    return note.pin === false;
  };
  const showNotes = notes.filter(checkUnpinNotes);

  return (
    <ul className="flex-col" >
      <p className="p3 bold center">Tasks</p>
      {showNotes.map((note) => {
        return (
          <li className="card" key={note._id}>
            <div className="card__primary-action card__primary-action-column">
              <Link
                className="text-dark"
                to={`/Pomodora/${note._id}`}
              >
                <div className="card__primary">
                  <h2 className="p3 bold">{note.title}</h2>
                  <p className="p2">{note.content}</p>
                  <ul className="flex card-badges">
                    {note.tags &&
                      note.tags.map((tag, index) => {
                        return (
                          <li key={index} className="tag">
                            <span className="tag-title">{tag}</span>
                          </li>
                        );
                      })}
                  </ul>
                  <div className="flex flex-align-end">
                    <p className=" p1 bold">{note.timer} Min</p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="card__actions">
              <p className="text-grey p1">Created on {note.date}</p>
              <div className="card__action-icons p3 text-grey">
                <MdOutlineArchive
                  name="archive item"
                  title="Archive"
                  className="ptr"
                  onClick={() => addToArchiveHandler(note, note._id)}
                />
                <MdDeleteOutline
                  name="trash item"
                  title="Trash"
                  className="ptr"
                  onClick={() => trashNoteHandler(note, note._id)}
                />
                <Link className="text-dark" to={`/${note.id}`}>
                  <MdOutlineEdit
                    name="edit"
                    title="Edit"
                    className="ptr"
                    onClick={() =>
                      dispatch({ type: "EDIT_NOTE", payload: note })
                    }
                  />
                </Link>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
